import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import {
    Card,
    CardContent,
    Box,
    CardHeader,
    Typography,
    LinearProgress,
    CardActionArea,
    Tooltip,
} from "@mui/material";

import PORTAvatar from "../PORTAvatar";

const PDPsCard = (props) => {
    const [pdps, setPdps] = useState(null);

    useEffect(() => {
        setPdps(props.data);
        setPdps(props.data);
    }, [props.data]);

    if (!pdps) return <LinearProgress />;

    const totalCount = pdps?.length ?? 0;

    return (
        <Card className="card">
            <CardActionArea
                component={Link}
                to={"/portfolio/pdps"}
                centerRipple={true}
            >
                <CardHeader
                    disableTypography={true}
                    avatar={
                        <Tooltip title="View all PDPs" arrow>
                            <PORTAvatar type={"pdp"} />
                        </Tooltip>
                    }
                    title={
                        <Typography
                            component="h2"
                            className="card-header-title"
                        >
                            PDPs
                        </Typography>
                    }
                    subheader={
                        <Typography
                            component="span"
                            className="card-header-subtitle"
                        >
                            Your PDPs
                        </Typography>
                    }
                />
            </CardActionArea>
            <CardContent>
                <Box className="card-content">
                    <Typography
                        variant="body1"
                        className="text"
                        sx={{ textAlign: "right" }}
                    >
                        {totalCount} PDPs
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
};

export default PDPsCard;
